import { FunctionComponent } from 'react';

import type { PresetKidMarkersContext } from '../../../hooks/usePresetKidMarkers';
import { PRESET_TABLE_EMPTY_STATE } from './presetTableEmptyState';
import { PresetTableShell } from './PresetTableShell';
import { useSeededSri } from './useSeededSri';

interface SRIChartInputProps {
  index: number;
  markerContext?: PresetKidMarkersContext;
}

/**
 * SRI (Synthetic Risk Indicator) preset block.
 * Seeds from FIG markers the same way set tables do (including Refresh override).
 */
export const SRIChartInput: FunctionComponent<SRIChartInputProps> = ({
  index,
  markerContext,
}) => {
  const { sriValue, isLoading, hasMarkers } = useSeededSri(index, markerContext);

  const renderBody = () => {
    if (isLoading && !hasMarkers) {
      return (
        <div className="rounded border border-gray-200 bg-gray-50 p-4 text-sm text-gray-500">
          Loading figure markers…
        </div>
      );
    }

    if (!hasMarkers || sriValue == null) {
      return PRESET_TABLE_EMPTY_STATE;
    }

    return (
      <>
        <label className="mb-2 block text-sm font-semibold text-gray-700">
          SRI Value (0-7) — auto-filled, read-only
        </label>

        <div className="rounded border border-gray-200 bg-gray-50 p-4">
          <div className="text-3xl font-bold text-mainblue">{sriValue}</div>
        </div>
      </>
    );
  };

  return (
    <PresetTableShell label="SRI" showLegend={false}>
      {renderBody()}
    </PresetTableShell>
  );
};

export default SRIChartInput;
